import axios, { isAxiosError } from 'axios';

import { AccountMappie } from '@/domain/user';

const ACCOUNTS_API = '/api/accounts';

export const getAllAccounts = async (): Promise<AccountMappie[] | []> => {
    try {
        const response = await axios.get<AccountMappie[]>(`/`, {
            baseURL: ACCOUNTS_API,
        });
        return response.data;
    } catch (error: any) {
        throw error;
    }
};
